<template>
    <div>
        <v-btn color="red darken-1" class="white--text" :disabled="selectedItems.length === 0 || isLoading"
            @click="openDeleteConfirmation">
            {{ $t('deleteCategories') }}
        </v-btn>
        <v-snackbar :color="snackColor" dark v-model="snackOpen" top v-if="snackOpen">
            <span class="caption pr-4">{{ $t('categoryBulkDeleteConfirmation') }}</span>
            <div>
                <v-btn text class="text--main-yellow" :disabled="isLoading" @click="deleteCategories">
                    {{ $t('yes') }}
                </v-btn>
                <v-btn text icon :disabled="isLoading" @click="closeDeleteConfirmation">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
import { CategoriesService } from '../../services';
import { areCategoriesAvailableForBulkDelete } from '../../model/utils';
import { MixinAppSnack } from '../../mixins';

export default {
    name: 'CategoriesBulkDelete',
    mixins: [MixinAppSnack],
    props: {
        selectedItems: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        openDeleteConfirmation() {
            if (!areCategoriesAvailableForBulkDelete(this.selectedItems)) {
                this.$emit('restricted');

                return;
            }

            this.setDeleteSnack();
            this.openSnack();
        },
        closeDeleteConfirmation() {
            this.resetSnack();
        },
        deleteCategories() {
            if (!areCategoriesAvailableForBulkDelete(this.selectedItems)) {
                this.closeDeleteConfirmation();
                this.$emit('restricted');

                return;
            }

            this.isLoading = true;

            CategoriesService.deleteMultiple({
                ids: this.selectedItems.map(item => item.id),
            })
                .then(response => {
                    this.$emit('update', { type: 'categoryBulkDelete', data: response.data });
                    this.closeDeleteConfirmation();
                })
                .catch(error => {
                    console.error('Error deleting categories:', error);
                    this.$emit('error', { type: 'categoryBulkDelete', data: error });
                    this.closeDeleteConfirmation();
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
